import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { Button } from 'react-bootstrap';

import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

class DateRangeSelection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectionRange: props.selectionRange,
      popupOpen: false,
    };

    this.handleSelect = this.handleSelect.bind(this);
    this.togglePopup = this.togglePopup.bind(this);
    this.openPopup = this.openPopup.bind(this);
    this.closePopup = this.closePopup.bind(this);
  }

  applyDate() {
    const { applyFilter, fetch } = this.props;
    const { selectionRange } = this.state;
    const { startDate, endDate } = selectionRange;
    const newSelectionRange = {
      ...selectionRange,
      startDate: moment(startDate).startOf('day').toDate(),
      endDate: moment(endDate).endOf('day').toDate(),
    };
    applyFilter('selectionRange', { ...newSelectionRange });
    fetch();
    this.closePopup();
  }

  handleSelect(selection) {
    this.setState({ selectionRange: selection.selection });
  }

  togglePopup() {
    this.setState({ popupOpen: !this.state.popupOpen });
  }

  openPopup() {
    this.setState({ popupOpen: true });
  }

  closePopup() {
    this.setState({ popupOpen: false });
  }

  render() {
    const { selectionRange: { startDate, endDate }, selectionRange, popupOpen } = this.state;
    return (
      <div className='filter-selection' data-popup-open={popupOpen}>
        <div className='filter-header'>
          <span className='text'>Date Selection:</span>
          <span className='input'>
            <span className='text' role='button' tabIndex={-1} onClick={this.togglePopup}>
              {moment(startDate).format('M/D/YYYY')}
            </span>
          </span>
          <span className='text'>to</span>
          <span className='input'>
            <span className='text' role='button' tabIndex={-1} onClick={this.togglePopup}>
              {moment(endDate).format('M/D/YYYY')}
            </span>
          </span>
          <span className='icon'>
            <i
              className='fas fa-calendar-alt'
              onClick={this.togglePopup}
              role='button'
              tabIndex={-1}
            />
          </span>
        </div>
        {popupOpen &&
          <div className='popup date-range'>
            <i
              className='close fas fa-times'
              role='button'
              tabIndex={-1}
              onClick={this.closePopup}
            />
            <DateRangePicker
              ranges={[selectionRange]}
              onChange={this.handleSelect}
            />
            <hr />
            <div style={{ width: '100%', padding: '0px 0px 15px', textAlign: 'center' }}>
              <Button className='btn btn-primary' onClick={this.applyDate.bind(this)}>Apply</Button>
            </div>
          </div>
        }
      </div>
    );
  }
}

DateRangeSelection.propTypes = {
  applyFilter: PropTypes.func.isRequired,
  fetch: PropTypes.func.isRequired,
  selectionRange: PropTypes.shape({}),
};

DateRangeSelection.defaultProps = {
  selectionRange: {},
};

export default DateRangeSelection;



// WEBPACK FOOTER //
// ./src/views/Components/DateRangeSelection.js